import { put } from "redux-saga/effects";
import { AuditLogsReportAction } from "../../action";
import { Client } from "../../../../utils/transport";
import { SOMETHING_WENT_WRONG } from "constants/staticText";
import { ExportCSV } from "utils/export-csv";
import dayjs from "dayjs";
import {
  actionModuleMap,
  getChangedModules,
  getCombinedDifferences,
  getDifferenceData,
} from "utils/auditlogUtils";
import { getDownloadTableViewColumns } from "utils/commonUtils";

const ExportData = (
  fileName,
  data,
  finalHeaders,
  filterDate,
  // teams,
  payload
) => {
  let result = [];
  const generatedDate =
    "Generated Date:-" + dayjs().format("DD-MM-YYYY hh:mm a");

  const generatedData = [
    fileName,
    // "Teams: - " + teams.join(",").replaceAll(",", "/"),
    "Date:-" + filterDate,
    generatedDate,
    finalHeaders.join(),
  ];
  data?.forEach((record) => {
    if (record?.action === "IDENTITY_CHANGED") return; // Skip this record

    const user = payload.user_map_data?.[record.actor];
    const targetModule = record?.meta?.user || record?.meta?.user_id;
    const differences = getCombinedDifferences(
      record?.meta?.old,
      record?.meta?.updated,
      "", // starting path
      targetModule
    );
    const keysBeforeSlash = Object.keys(differences).map(
      (key) => key.split(" / ")[0]
    );

    const employeeName =
      payload?.user_map_data[record?.meta?.actor]?.identity?.first_name +
      " " +
      payload?.user_map_data[record?.meta?.actor]?.identity?.last_name;
    const dynamicValues = getDownloadTableViewColumns(
      payload.viewFields,
      user,
      payload.team_map_data
    );
    const dataArray = getDifferenceData(record, payload.team_map_data);

    const fixedValues = [
      dayjs(record.last_modified_date).format("YYYY-MM-DD hh:mm A"),
      actionModuleMap[record.action] || "Unknown Module",
      record?.action === "USER_INFO_CHANGED" ||
      record?.action === "IDENTITY_CHANGED" ||
      record?.action === "USER_ACTIVATED" ||
      record?.action === "USER_DEACTIVATED"
        ? "User"
        : record.action === "GROUP_SETTINGS_CHANGED"
        ? "Team"
        : getChangedModules(
            record?.meta?.existing,
            record?.meta?.new,
            record?.meta?.user
          ),

      targetModule
        ? `${
            payload?.user_map_data?.[targetModule]?.identity?.first_name || ""
          } ${
            payload?.user_map_data?.[targetModule]?.identity?.last_name || ""
          }`
        : dataArray, // spread the dynamic differences at the end
    ];
    generatedData.push(
      [employeeName, ...dynamicValues, ...fixedValues].join(",")
    );
  });
  result = generatedData;
  return result;
};

const getDownloadCSV = (payload, data) => {
  const auditlogData = data?.data;

  const date =
    dayjs(
      payload?.payload.body?.greaterThanOrEqualTo.last_modified_date
    ).format("YYYY-MM-DD") +
    " To " +
    dayjs(payload?.payload.body?.lessThanOrEqualTo.last_modified_date).format(
      "YYYY-MM-DD"
    );
  // Dynamic columns
  const dynamicFields = payload.payload.viewFields || [];
  const dynamicHeaders = dynamicFields.map((field) => field.label);

  // Fixed headers
  const fixedHeaders = [
    "Timestamp",
    "Action Performed",
    "Target Module",
    "Difference",
  ];

  const finalHeaders = [
    "Actor Name", // full name
    ...dynamicHeaders,
    ...fixedHeaders,
  ];

  const exdata = ExportData(
    "Audit log Report",
    auditlogData,
    finalHeaders,
    date,
    // selectTeamNames,
    payload.payload
  );
  ExportCSV("Audit_Logs_Report_", exdata);
};
export function* fetchAuditLogsReportSaga(action) {
  const config = {
    method: "POST",
    // url: `api/v1/admin/audit_logs`,
    url: `/api/v1/admin/audit_logs/?${action.payload.query}`,

    headers: {
      ...action.payload.headers,
    },
    data: { ...action.payload.body },
    // data: {},
  };

  try {
    const response = yield Client.request(config);
    yield put(AuditLogsReportAction.fetchAuditLogsReportSuccess(response.data));
  } catch (err) {
    let errorMessage = SOMETHING_WENT_WRONG;
    if (err.response?.status < 500) {
      errorMessage = err.response?.data?.errors?.[0]?.detail;
    }
    yield put(AuditLogsReportAction.fetchAuditLogsReportFailed(errorMessage));
  }
}

export function* downloadAuditLogsReportSaga(action) {
  const config = {
    method: "POST",
    url: `/api/v1/admin/audit_logs/?${action.payload.query}`,
    headers: {
      ...action.payload.headers,
    },
    data: { ...action.payload.body },
  };

  try {
    const response = yield Client.request(config);
    getDownloadCSV(action, response.data);

    yield put(
      AuditLogsReportAction.downloadAuditLogsReportSuccess(response.data)
    );
  } catch (err) {
    console.log(err);
    let errorMessage = SOMETHING_WENT_WRONG;
    if (err.response?.status < 500) {
      errorMessage = err.response?.data?.errors?.[0]?.detail;
    }
    yield put(
      AuditLogsReportAction.downloadAuditLogsReportFailed(errorMessage)
    );
  }
}
